module.exports = __webpack_public_path__ + "img/openoffice.9c90bac9.png";